import React , {useState , useContext} from 'react';
import "./foodTypeFilter.css" ;
import RestaurentContext  from '../../../../context/rest_context';
import { FoodType } from '../../../../models/Restaurent_food_model';



const SwitchTile = ({ name, activeName, setActiveName }) => {
  const {setFilterRestItems , restItems} = useContext(RestaurentContext);

  const switchTileClass = name === 'Veg' ? 'switch-tile veg' : 'switch-tile non-veg';
  const isActive = name === activeName;

  const handleClick = () => {
    if (isActive) {
      setActiveName(null); // Deactivate the switch tile
      setFilterRestItems(restItems);
    } else {
      setActiveName(name); // Activate the switch tile
      if(name == "Veg"){
          const filterData = restItems.filter(item => item.type === FoodType.VEG);
          setFilterRestItems(filterData);
        }else{
        const filterData = restItems.filter(item => item.type === FoodType.NON_VEG);
        setFilterRestItems(filterData);

      }
    }
  };

  return (
    <div className={switchTileClass}>
      <input
        type="checkbox"
        name={name}
        id={name}
        className="switch-input"
        checked={isActive}
        onChange={handleClick}
      />
      <label htmlFor={name} className="switch-box"></label>
      <p htmlFor={name}>{name}</p>
    </div>
  );
};


const FoodTypeFilter = () => {
 

  const [activeName, setActiveName] = useState(null);

  return (
    <div className="food-filter-container">
      <SwitchTile name="Veg" activeName={activeName} setActiveName={setActiveName} />
      <SwitchTile name="Non Veg" activeName={activeName} setActiveName={setActiveName} />
    </div>
  );
};

export default FoodTypeFilter;
